import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Atendimento} from '../_model/atendimento';

const pathApi = 'Atendimento';

@Injectable({
  providedIn: 'root',
})
export class AtendimentoService {

  constructor(private http: HttpClient) {
  }

    getAll(): Observable<Atendimento[]> {
      return this.http.get<Atendimento[]>(`${environment.URL_API}/${pathApi}/home`);
    }

    get(id: string): Observable<Atendimento> {
        return this.http.get<Atendimento>(`${environment.URL_API}/${pathApi}/telefone/${id}`);
    }
}
